import { createPortal } from 'react-dom'
import { Trans } from 'react-i18next'

import { FunctionItem, FunctionItemDefaultValue, FunctionValue } from '@makyoapp/makyo-common'
import { Tabs, Tip, useTip } from '@makyoapp/makyo-ui'

import { cn } from '@/lib/cn'

interface FunctionNavItemProps {
  item: FunctionItem
  onChange: (next: FunctionValue) => void
  isActive: boolean
}

export function FunctionNavItem({ item, onChange, isActive }: FunctionNavItemProps) {
  const {
    x,
    y,
    strategy,
    refs,
    context,
    placement,
    isOpen: isTipOpen,
    arrowRef,
    getReferenceProps,
    getFloatingProps,
  } = useTip({
    placement: 'left',
  })

  const handleClickFnItem = () => {
    const nextValue: Record<string, FunctionItemDefaultValue> = {}

    for (const f of item.fields) {
      if (f.defaultValue !== undefined) {
        nextValue[f.id] = f.defaultValue as FunctionItemDefaultValue
      }
    }

    onChange({
      item: {
        id: item.id,
        fn: item.fn,
        title: item.title,
      },
      value: nextValue,
    })
  }

  return (
    <Tabs.NavItem
      eventKey={item.id}
      navItemStyle='none'
      onClick={handleClickFnItem}
      className={cn('function-menu-item', isActive && 'active')}
    >
      <div className='flex flex-col text-start min-w-1 truncate'>
        <span ref={refs.setReference} className='text-m-sm' {...getReferenceProps()}>
          {item.title}
        </span>

        {isTipOpen &&
          createPortal(
            <Tip
              className='max-w-[300px] text-m-m'
              x={x}
              y={y}
              placement={placement}
              strategy={strategy}
              ref={refs.setFloating}
              {...getFloatingProps()}
              context={context}
              arrowRef={arrowRef}
            >
              <div className='text-m-sm'>
                <Trans i18nKey={`fn.${item.id}.short`} />
              </div>
            </Tip>,
            document.body
          )}
      </div>
    </Tabs.NavItem>
  )
}
